module.exports = __webpack_public_path__ + "img/CombinedShape2.32bdc750.svg";